/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';
const billRoutes = {
  path: '/bill',
  component: Layout,
  redirect: '/bill',
  name: 'Bill',
  alwaysShow: true,
  meta: {
    title: 'Bill',
    icon: 'Wallet',
  },
  children: [
    /** Sale Bill managements */
    {
      path: 'sale-bill/list',
      component: () => import('../views/bill/SaleBill/List'),
      name: 'saleBill',
      meta: { title: 'Sales Bill', icon: 'Memo', permissions: ['sales bill view'] },
    },
    {
      path: 'sale-bill/create',
      component: () => import('../views/bill/SaleBill/Create'),
      name: 'saleBillCreate',
      meta: { title: 'saleBillCreate', icon: 'Memo', permissions: ['sales bill create'] },
      hidden: true,
    },
    {
      path: 'sale-bill/edit/:id',
      component: () => import('../views/bill/SaleBill/Edit'),
      name: 'saleBillEdit',
      meta: { title: 'saleBillEdit', icon: 'Memo', permissions: ['sales bill update'] },
      hidden: true,
    },
    {
      path: 'sale-bill/view/:id',
      component: () => import('../views/bill/SaleBill/View'),
      name: 'saleBillView',
      meta: { title: 'saleBillView', icon: 'Memo', permissions: ['sales bill view'] },
      hidden: true,
    }
  ],
};

export default billRoutes;
